export default __webpack_public_path__ + "static/media/up.f35f5a07.svg";